<template>
  <div>
    <iModal
      :title="modelTitle"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          > 
            <FormItem label="展会名称：" prop="name">
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="展会海报：" prop="cover">
              <div>
                <upload
                  ref="upload1"
                  :fileList="uploadCover"
                  :config="uploadCoverConfig"
                  @upload-ok="bannerOK"
                />
              </div>
            </FormItem>
            <FormItem label="展会时间：" prop="time">
              <Input v-model="formInline.time" />
              <!-- <DatePicker
                type="date"
                format="yyyy-MM-dd"
                placeholder="请选择展会时间"
                style="width: 408px;"
                v-model="formInline.time"
              ></DatePicker> -->
            </FormItem>
            <FormItem label="展会地点：" prop="address">
              <Input v-model="formInline.address" />
            </FormItem>
            <FormItem label="展会链接：" prop="link">
              <Input v-model="formInline.link" />
            </FormItem>
            <FormItem label="展会简介：" prop="description">
              <Input type="textarea" maxlength="200" show-word-limit :autosize="{minRows: 5,maxRows: 5}" v-model="formInline.description" />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
let moment = require("moment");
import { mapGetters, mapActions } from "vuex";
import upload from "@components/upLoad/upLoad";

export default {
  name: "classify-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    modelTitle:{
      type:String,
    },
    options:{
      type:Object
    },
  },
  data() {
    const that = this;
    const validateCover = (rule, value, callback) => {
      if (that.uploadCover && that.uploadCover.length) {
        callback();
      } else {
        callback(new Error("请上传展会海报"));
      }
    };
    return {
      uploadCover: [],
      loading: false,
      showModal: false,
      editId:'',
      formInline: {
        // form双向绑定
        name: "",
        time:'',
        address: "",
        description: "",
        link: ""
      },
      ruleInline: {
        name: [{ required: true, message: "必填选项", trigger: "blur" }],
        cover: [{ required: true, validator: validateCover }],
      },
      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind:
          "（要求：2M以内的jpg，png格式图片，建议尺寸340*460px）",
        limitNum: 1
      },
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo(){
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    header() { return this.$store.state.header},
    uploadCoverConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options(val){
      if(val.msg){
        this.formInline.name = val.msg.name;
        this.formInline.time = val.msg.time;
        this.formInline.address = val.msg.address;
        this.formInline.description = val.msg.description;
        this.formInline.link = val.msg.link;
        if (val.msg.cover) {
          this.uploadCover.push(val.msg.cover);
        }
        this.editId = val.msg.id;
      }
    }
  },
  created() {},
  methods: {
    ...mapActions({
      addExPlan: "categoryModule/addExPlan",
      putExPlan: "categoryModule/putExPlan"
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      
      this.loading = true;
      
      // 编辑模式
      if(this.options.model){ 
        this.editPro(form);
      } else { // 新增模式
        this.addPro(form);
      }
    },
    async addPro(form){
      let body = {
        "Cover": this.uploadCover[0],
        "Name": form.name,
        // "Time": moment(form.time).format("YYYY-MM-DD"),
        "Time": form.time,
        "Address": form.address,
        "Description": form.description,
        "Link": form.link,
      }
      let bool = await this.addExPlan(body);
      if (bool && bool.successed) {
        this.loading = false;
        this.$Message.success("添加成功！");
        this.cancel();
        this.$emit('finish');
      } else {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      }
    },
    async editPro(form){
      let body = {
          "Id":this.editId,
          "SetValues":{
            "Cover": this.uploadCover[0],
            "Name": form.name,
            // "Time": moment(form.time).format("YYYY-MM-DD"),
            "Time": form.time,
            "Address": form.address,
            "Description": form.description,
            "Link": form.link,
          }
      }
      let bool = await this.putExPlan(body);
      if (bool && bool.successed) {
        this.loading = false;
        this.$Message.success("修改成功！");
        this.cancel();
        this.$emit('finish');
      } else {
        this.loading = false;
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
      this.formInline={
        name:'',
        time: "",
        address:"",
        description:'',
        link: ""
      };
      this.uploadCover = [];
      this.editId = '';
    },
    bannerOK(list) {
      this.uploadCover = list;
    },
  },
  components: {
    upload
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

